/* The second-factor step's states (routes/SecondFactorStep.tsx): which one it
 * opens in, and which follows a code the server accepted. */
import type { SecondFactorMethod, StepStatus, TotpEnrolment } from "../api/secondFactor";

/* `sent` is whether this screen has emailed a code, so the email view offers to
 * send one rather than asking for one nobody sent. `addTotp` is a person
 * holding email who asked to set up an authenticator: the server starts one
 * only once this sign-in has passed the step (app/second_factor.py
 * may_add_totp), so the emailed code comes first and the setup follows it. */
export type View =
  | { kind: "choose" }
  | {
      kind: "enter";
      method: SecondFactorMethod;
      enrolment?: TotpEnrolment;
      sent?: boolean;
      addTotp?: boolean;
    }
  | { kind: "codes"; codes: string[]; addTotp?: boolean }
  /* The step is passed and the authenticator asked for is being started. */
  | { kind: "adding" };

/* Entering a code for a method already held, the authenticator first, or
 * choosing one when none is. */
export function firstView(status: StepStatus): View {
  if (status.methods.includes("totp")) return { kind: "enter", method: "totp" };
  if (status.methods.includes("email")) return { kind: "enter", method: "email", sent: false };
  return { kind: "choose" };
}

/* What follows a code the server accepted: new recovery codes first, then the
 * authenticator setup if one was asked for, else the product. */
export type AfterVerify =
  | { kind: "codes"; codes: string[]; addTotp: boolean }
  | { kind: "addTotp" }
  | { kind: "finish" };

export function afterVerify(addTotp: boolean, recoveryCodes: string[] | null): AfterVerify {
  if (recoveryCodes) return { kind: "codes", codes: recoveryCodes, addTotp };
  return addTotp ? { kind: "addTotp" } : { kind: "finish" };
}
